import { Show } from "shared/components";
import { useMedia } from "shared/providers";
import { PromoFeatureName, PromoSize } from "shared/components/Promo/types";
import {
  useShowChatInboxPromo,
  useShowPromo
} from "shared/components/Promo/hooks";
import { PromoModal } from "shared/components/Promo/Modal";
import { PromoBanner } from "shared/components/Promo/Banner";

export const Promos = () => {
  const { isDesktopSm } = useMedia();
  const { showPromoModal, showPromoBanner } = useShowPromo();
  const { showChatInboxModal, showChatInboxBanner } = useShowChatInboxPromo();

  const modalSize = isDesktopSm ? PromoSize.SM : PromoSize.BASE;

  return (
    <>
      <Show if={showPromoModal}>
        <PromoModal
          featureName={PromoFeatureName.CombinedIncome}
          size={modalSize}
        />
      </Show>
      <Show if={showPromoBanner}>
        <PromoBanner
          featureName={PromoFeatureName.CombinedIncome}
          size={PromoSize.XS}
        />
      </Show>
      <Show if={showChatInboxModal}>
        <PromoModal
          featureName={PromoFeatureName.ChatMovedToInbox}
          size={modalSize}
        />
      </Show>
      <Show if={showChatInboxBanner}>
        <PromoBanner
          featureName={PromoFeatureName.ChatMovedToInbox}
          size={PromoSize.XS}
        />
      </Show>
    </>
  );
};
